import {h} from "preact";
import { useState } from 'preact/hooks';
import cx from 'classnames';
import './index.less';


/**
 * 按钮
 * @param Element {string}
 * @param className
 * @param type
 * @param disableLoading
 * @param children
 * @param onClick
 * @param props
 * @returns {ComponentChildren}
 * @constructor
 */
const Button = ({ Element = 'button', className, type = 'default', disableLoading = false, children, onClick, ...props }) => {
  const [loadingStatus, setLoadingStatus] = useState(false);
  const typeStyles = {
    default: 'default',
    primary: 'primary',
    disable: 'disable'
  };
  // noinspection JSXNamespaceValidation
  return (
    <Element
      className={cx('xfe_common_button_root', typeStyles[type] === 'disable' ? cx(typeStyles[type], 'disable') : typeStyles['default'], className)}
      onClick={async e => {
        if (e.target.blur) {
          e.target.blur();
        }
        e.stopPropagation();
        e.preventDefault();
        if (type !== 'disable') {
          !disableLoading && setLoadingStatus(true);
          try {
            await onClick(e);
          } catch (e) {}
          !disableLoading && setLoadingStatus(false);
        }
      }}
      children={!loadingStatus ? children : [children, '  ', '...']}
      {...props}
    />
  );
};

export default Button;
